export default __webpack_public_path__ + "3c2c71a2f9ddd6364918d024767fdf38.svg";